import { useState, useEffect } from "react";
import {useUserServiceApi} from "../../api/auth/auth-api.js";

function LogoutButtonMobile() {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 760);
    const { logoutUser } = useUserServiceApi();

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 730);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    if (!isMobile) return null; // Render only if screen size is mobile

    return (
        <div className="">
            <svg
                onClick={() => logoutUser.mutate()}
                width="30" height="30" fill="none" stroke="#ef4444" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
                <path d='M13.496 21H6.5c-1.105 0-2-1.151-2-2.571V5.57c0-1.419.895-2.57 2-2.57h7M16 15.5l3.5-3.5L16 8.5m-6.5 3.496h10'/>
            </svg>
        </div>

    );
}

export default LogoutButtonMobile;